(function ($, njm) {
    'use strict';

    njm.views.accordion = Backbone.View.extend({

        events: {
            'click .accordion-title': 'toggle'
        },

        /**
         * Initialize
         */
        initialize: function () {
            if (!this.isPageEditor()) {
                this.collapse(this.$('.accordion-item'));
            }
        },

        /**
         * Is Page Editor
         * @returns {boolean}
         */
        isPageEditor: function () {
            return !!(window.Sitecore && window.Sitecore.PageModes && window.Sitecore.PageModes.PageEditor);
        },

        /**
         * Toggle clicked accordion
         * @param {Object} e
         */
        toggle: function (e) {
            e.preventDefault();
            var $target = $(e.currentTarget).parents('.accordion-item');

            if ($target.hasClass('collapsed')) {
                this.expand($target);
            } else {
                this.collapse($target);
            }
        },

        /**
         * Collapse accordion
         * @param {Object} target
         */     
        collapse: function (target) {
            target.addClass('collapsed');
            target.find('.accordion-title').attr('aria-expanded', false);
            target.find('.accordion-title > .icon-minus').removeClass('icon-minus').addClass('icon-plus');

            //target.find('.accordion-content').slideUp().attr('aria-hidden', true); //UPDATE TO BELOW

            target.find('.accordion-content').slideUp(function () {
                $(this).attr('aria-hidden', true);
            });
        },

        /**
         * Expand accordion
         * @param {Object} target
         */
        expand: function (target) {
            target.removeClass('collapsed');
            target.find('.accordion-title').attr('aria-expanded', true);
            target.find('.accordion-title > .icon-plus').removeClass('icon-plus').addClass('icon-minus');
            target.find('.accordion-content').slideDown().attr('aria-hidden', false);
        }
    });
})(jQuery, njm);
